import React from 'react';

function Portfolio(){
    return (
        <div>
            <section id="portfolio" className="link-section responsive">
                <div className="wrapper">
                    <h2 className="section-heading wrapper">Portfolio</h2>
                    <p className="subtitle">Press Thumbnail to Enter Website Project App. For thumbnails with Github Icons, press Project Name for Repo.</p>

                    <div id="works-square">
                    <div id="project0" className="square-container">
                            <h3><a href="https://github.com/leonhsu95/the-cold-drip">The Cold Drip</a></h3>
                            <div className="works-container">
                                <a href=" https://the-cold-drip.herokuapp.com/"><img className="square" src="assets/designs/the-cold-drip-square.png" alt="The Cold Drip ECommerce"></img>
                                <div className="overlay">
                                    <div className="works-text">
                                        <p><span className="works-tag1">Solo Project</span><br></br><span className="works-tag2">The Cold Drip</span></p>
                                    </div>
                                </div>
                                </a>
                            </div>
                        </div>

                        <div id="project1" className="square-container">
                            <h3><a href="https://github.com/leonhsu95/Projectify">Projectify</a></h3>
                            <div className="works-container">
                                <a href="https://projectify-marketing-app.herokuapp.com/"><img className="square" src="assets/designs/projectify-square.png" alt="Projectify"></img>
                                <div className="overlay">
                                    <div className="works-text">
                                        <p><span className="works-tag1">Team Project</span><br></br><span className="works-tag2">Projectify</span></p>
                                    </div>
                                </div>
                                </a>
                            </div>
                        </div>

                        <div id="project2" className="square-container">
                            <h3><a href="https://github.com/leonhsu95/ReaCharity">ReaCharity</a></h3>
                            <div className="works-container">
                                <a href="https://leonhsu95.github.io/ReaCharity/"><img className="square" src="assets/designs/reacharity-square.png" alt="Reacharity"></img>
                                <div className="overlay">
                                    <div className="works-text">
                                        <p><span className="works-tag1">Team Project</span><br></br><span className="works-tag2">Learning Delights <br></br> Book Club</span></p>
                                    </div>
                                </div>
                                </a>
                            </div>
                        </div>

                        <div id="project3" className="square-container">
                        <h3><a href="https://github.com/leonhsu95/book-search-engine">Book Search Engine</a></h3>
                            <div className="works-container">
                                    <a href="https://book-search-engine-lh.herokuapp.com/"><img className="square" src="assets/designs/book-search-engine-square.png" alt="Book Search Engine"></img>
                                    <div className="overlay">
                                    <div className="works-text"><p><span className="works-tag1">MongoDb Express App</span><br></br><span className="works-tag2">Book Search Engine</span></p></div>
                                    </div>
                                    </a>
                            </div>
                        </div>

                        <div id="project4" className="square-container">
                        <h3><a href="https://github.com/leonhsu95/budget-tracker">Budget Tracker</a></h3>
                            <div className="works-container">
                                    <a href="https://budget-tracker-lh.herokuapp.com/"><img className="square" src="assets/designs/budgettracker-square.jpg" alt="Budget Tracker"></img>
                                    <div className="overlay">
                                    <div className="works-text"><p><span className="works-tag1">MongoDb Express App</span><br></br><span className="works-tag2">Budget Tracker</span></p></div>
                                    </div>
                                    </a>
                            </div>
                        </div>

                        <div id="project5" className="square-container">
                        <h3><a href="https://github.com/leonhsu95/workout-tracker">Workout Tracker</a></h3>
                            <div className="works-container">
                                <a href="https://workout-tracker-lh.herokuapp.com/"><img className="square" src="assets/designs/workouttracker-square.jpg" alt="Workout Tracker"></img>
                                <div className="overlay">
                                    <div className="works-text"><p><span className="works-tag1">MongoDb Express App</span><br></br><span className="works-tag2">Workout Tracker</span></p></div>
                                </div>
                                </a>
                            </div>
                        </div>

                        <div id="project6" className="square-container">
                        <h3><a href="https://github.com/leonhsu95/tech-blog">The Tech Word Blog</a></h3>    
                            <div className="works-container">
                            <a href="https://tech-blog-lh.herokuapp.com/"><img className="square" src="assets/designs/thetechwordblog-square.jpg" alt="The Tech Word Blog"></img>
                                <div className="overlay">
                                    <div className="works-text"><p><span className="works-tag1">Coded CMS</span><br></br><span className="works-tag2">The Tech Word Blog</span></p></div>
                                </div>
                                </a>
                            </div>
                        </div>

                        <div id="project7" className="square-container">
                            <h3>Learning Delights Book Club</h3>
                            <div className="works-container">
                                <a href="https://learningdelights.com.au/"><img className="square" src="assets/designs/learningdelights-square.png" alt="Learning Delights Book Club"></img>
                                    <div className="overlay">
                                        <div className="works-text"><p><span className="works-tag1">Blogging</span><br></br><span className="works-tag2">Learning Delights <br></br> Book Club</span></p></div>
                                    </div>
                                </a>
                            </div>
                        </div>

                        <div id="project8" className="square-container">
                            <h3>Sydney Property Valuations</h3>    
                            <div className="works-container">
                                    <a href="https://sydneypropertyvaluations.com.au/"><img className="square" src="assets/designs/sydneysuburbanpropertyvaluations-square.png" alt="Sydney Suburban Property Valuations"></img>
                                    <div className="overlay">
                                        <div className="works-text"><p><span className="works-tag1">Business Website Redesign</span><br></br><span className="works-tag2">Sydney Suburban Property Valuations</span></p></div>
                                    </div>
                                    </a>
                            </div>
                        </div>

                        <div id="project9" className="square-container">
                            <h3>Sydney Contacts</h3> 
                            <div className="works-container">
                                    <a href="https://sydneycontacts.com.au/"><img className="square" src="assets/designs/sydneycontacts-square.png" alt="Sydney Contacts"></img>
                                    <div className="overlay">
                                    <div className="works-text"><p><span className="works-tag1">WooCommerce Dropship</span><br></br><span className="works-tag2">Sydney Contacts</span></p></div>
                                    </div>
                                    </a>
                            </div>
                        </div>

                        <div id="project10" className="square-container">
                            <h3>Idol Eyes Australia</h3>       
                            <div className="works-container">
                                <a href="https://idoleyes.com.au/"><img className="square" src="assets/designs/idoleyes-square.png" alt="Idol Eyes Australia"></img>
                                <div className="overlay">
                                    <div className="works-text"><p><span className="works-tag1">WooCommerce Dropship</span><br></br><span className="works-tag2">Idol Eyes Australia</span></p></div>
                                </div>
                                </a>
                            </div>
                        </div>

                        <div id="project11" className="square-container">
                            <h3>Hills Family Physio</h3>       
                            <div className="works-container">
                            <a href="https://hillsfamilyphysio.com.au/"><img className="square" src="assets/designs/hillsfamilyphysio-square.png" alt="Hills Family Physio"></img>
                                <div className="overlay">
                                    <div className="works-text"><p><span className="works-tag1">Business Site</span><br></br><span className="works-tag2">Hills Family Physio</span></p></div>
                                </div>
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </div>        
    )
}

export default Portfolio;